import { PurchaseConditionsActiveFilters } from '@/modules/purchase-conditions';
import gql from 'graphql-tag';
import { executeQuery } from '../client';
import { PurchaseConditionsGroupByCircuit } from '@/models/purchase-condition/purchase-conditions-group-by-circuit';

const PURCHASE_CONDITIONS_QUERY = gql`
  query purchaseConditionsGroupByCircuit($supplierCode: Int) {
    purchaseConditionsGroupByCircuit(supplierCode: $supplierCode) {
      CROSSDOCK {
        ...BasePurchaseConditionFields
      }
      DIRECT {
        ...BasePurchaseConditionFields
      }
      LDD {
        ...BasePurchaseConditionFields
      }
      WAREHOUSE {
        ...BasePurchaseConditionFields
      }
    }
  }

  fragment BasePurchaseConditionFields on BasePurchaseCondition {
    id
    supplierCode
    supplierCorpName
    ean
    ref
    designation
    beginDate
    billingUnit
    circuit
    incoTerm
    pcbPackaging
    francoAmount
    francoUnit
    netPrice
    selection {
      status
    }
  }
`;

export async function getPurchaseConditionsGroupByCircuit(
  filters: Partial<PurchaseConditionsActiveFilters>
): Promise<PurchaseConditionsGroupByCircuit> {
  const { purchaseConditionsGroupByCircuit } = await executeQuery<{
    purchaseConditionsGroupByCircuit: PurchaseConditionsGroupByCircuit;
  }>(PURCHASE_CONDITIONS_QUERY, filters);

  return purchaseConditionsGroupByCircuit;
}
